/**
 * Developer mode for VIADS Studio.
 *
 * When enabled:
 * - Rendering is skipped
 * - Player/Overlay tabs are enabled without rendering
 * - Publish uses the original media file from Rendley library
 *
 * To enable: localStorage.setItem('isStudioInDevMode', 'true')
 * Then refresh the page.
 */
export const isStudioInDevMode =
  localStorage.getItem('isStudioInDevMode') === 'true';
